import styled from 'styled-components'

export const ManagePickupTimesWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`
